<template>
    <input
        :placeholder="placeholder"
        :type="type"
        class="
            form-input
            border
            rounded-full
            w-full
            selected:border-blue-800
            disabled:text-gray-500
            disabled:border-gray-300 disabled:bg-gray-300
            form-textarea
        "
        :class="stateClasses"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
    />
</template>

<script>
import Textarea from "@/Components/Textarea.vue";
import Icon from "@/Components/UI/Icons/Icon.vue"

export default {
    components: { Textarea, Icon },
    props: {
        type: {
            type: String,
            default: "text",
        },
        state: {
            type: String,
            default: "default",
        },
        modelValue: {
            type: String,
        },
        placeholder: {
            type: String,
        }
    },
    computed: {
        stateClasses() {
            if (this.state == "success") {
                return "border-green-500";
            }
            if (this.state == "error") {
                return "border-red-500";
            }
            return "border-gray-500";
        },

        stateName() {
            if (this.state == "success") {
                return "Sucesso";
            }
            if (this.state == "error") {
                return "Erro";
            }
        },
    },
    methods: {
        updateValue(value) {
            ///console.log(value);
            this.$emit("update-value", value);
        },
    },
};
</script>
